'use strict';

exports.__esModule = true;

var _styledBase = require('@emotion/styled-base');

var _styledBase2 = _interopRequireDefault(_styledBase);

var _core = require('@emotion/core');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return 'You have tried to stringify object returned from `css` function. It isn\'t supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).';
}

var _ref = process.env.NODE_ENV === 'production' ? {
  name: 'ah3opm-InputGroup',
  styles: 'box-shadow:rgb(0 0 0 / 20%) 0px 0px 15px;;label:InputGroup;'
} : {
  name: 'ah3opm-InputGroup',
  styles: 'box-shadow:rgb(0 0 0 / 20%) 0px 0px 15px;;label:InputGroup;',
  map: '/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9zdHlsZXMvSW5wdXRHcm91cC5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFZUSIsImZpbGUiOiIuLi8uLi9zcmMvc3R5bGVzL0lucHV0R3JvdXAuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBjc3MgfSBmcm9tICdAZW1vdGlvbi9jb3JlJztcbmltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJztcblxuY29uc3QgSW5wdXRHcm91cCA9IHN0eWxlZC5kaXZgXG5cdGRpc3BsYXk6IGZsZXg7XG5cdGFsaWduLWl0ZW1zOiBzdHJldGNoO1xuXHR3aWR0aDogMTAwJTtcblx0Ym94LXNoYWRvdzogcmdiKDAgMCAwIC8gMjAlKSAwcHggMHB4IDZweDtcblx0Ym9yZGVyLXJhZGl1czogNnB4O1xuXG5cdCR7cHJvcHMgPT5cblx0cHJvcHMuaXNPcGVuXG5cdFx0JiYgY3NzYFxuXHRcdFx0Ym94LXNoYWRvdzogcmdiKDAgMCAwIC8gMjAlKSAwcHggMHB4IDE1cHg7XG5cdFx0YH07XG5gO1xuXG5JbnB1dEdyb3VwLmRlZmF1bHRQcm9wcyA9IHsgY2xhc3NOYW1lOiAnaW5wdXQtZ3JvdXAnIH07XG5cbmV4cG9ydCBkZWZhdWx0IElucHV0R3JvdXA7XG4iXX0= */',
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};

var InputGroup = (0, _styledBase2.default)('div', {
  target: 'ed6sflt0',
  label: 'InputGroup'
})('display:flex;align-items:stretch;width:100%;box-shadow:rgb(0 0 0 / 20%) 0px 0px 6px;border-radius:6px;', function (props) {
  return props.isOpen && _ref;
}, ';' + (process.env.NODE_ENV === 'production' ? '' : '/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9zdHlsZXMvSW5wdXRHcm91cC5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFHNkIiLCJmaWxlIjoiLi4vLi4vc3JjL3N0eWxlcy9JbnB1dEdyb3VwLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgY3NzIH0gZnJvbSAnQGVtb3Rpb24vY29yZSc7XG5pbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCc7XG5cbmNvbnN0IElucHV0R3JvdXAgPSBzdHlsZWQuZGl2YFxuXHRkaXNwbGF5OiBmbGV4O1xuXHRhbGlnbi1pdGVtczogc3RyZXRjaDtcblx0d2lkdGg6IDEwMCU7XG5cdGJveC1zaGFkb3c6IHJnYigwIDAgMCAvIDIwJSkgMHB4IDBweCA2cHg7XG5cdGJvcmRlci1yYWRpdXM6IDZweDtcblxuXHQke3Byb3BzID0+XG5cdHByb3BzLmlzT3BlblxuXHRcdCYmIGNzc2Bcblx0XHRcdGJveC1zaGFkb3c6IHJnYigwIDAgMCAvIDIwJSkgMHB4IDBweCAxNXB4O1xuXHRcdGB9O1xuYDtcblxuSW5wdXRHcm91cC5kZWZhdWx0UHJvcHMgPSB7IGNsYXNzTmFtZTogJ2lucHV0LWdyb3VwJyB9O1xuXG5leHBvcnQgZGVmYXVsdCBJbnB1dEdyb3VwO1xuIl19 */'));
InputGroup.defaultProps = {
  className: 'input-group'
};
exports.default = InputGroup;